import { Badge, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../store/Hooks'
import { changeRoute } from '../../store/slices/SessionSlice'
import { Route } from '../routing/Routing'
import RouteIcon from '../routing/RouteIcon'

interface P {
    route: Route
    label: string
    notifies?: number
}

function NavigationRoute({ label, route, notifies }: P) {
    const dispatch = useAppDispatch()
    const history = useAppSelector(s => s.session.routeHistory)
    const currentRoute = history?.at(0)?.route
    const isSelected = route === currentRoute

    return (
        <ListItemButton
            sx={{
                borderRadius: 2,
                marginBottom: 1,
                bgcolor: isSelected ? 'var(--primary-selected)' : undefined,
                position: 'relative'
            }}
            onClick={() => dispatch(changeRoute({ route }))}>
            <ListItemIcon sx={{ minWidth: 'calc(var(--unit)*5)', position: 'relative' }}>
                <Badge
                    badgeContent={notifies}
                    color='error'
                    invisible={!notifies || notifies <= 0}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}>
                    <RouteIcon icon={route} style={{ opacity: 0.55, fontSize: '1.4rem' }} />
                </Badge>
            </ListItemIcon>
            <ListItemText primary={label} />
        </ListItemButton>
    )
}

export default NavigationRoute
